import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import CheckoutForm from './CheckoutForm'
import { CircularProgressContinuous } from '@/components/loaders/CircularProgressContinuous'

type CheckoutContainerProps = {
  clientSecret: string | null
  checkoutButtonCopy?: string
  supportTrial?: boolean
}

// loadStripe should be called outside the components render to avoid recreating the stripe instance on every render
const stripePromise = loadStripe(import.meta.env.VITE_PUBLISHABLE_STRIPE_KEY)

const CheckoutContainer: React.FC<CheckoutContainerProps> = ({ clientSecret, checkoutButtonCopy, supportTrial }) => {
  const appearance = {
    theme: 'stripe' as const,
    variables: {
      colorPrimary: '#2A49FF',
      colorBackground: '#fff',
      colorText: '#374151',
      colorDanger: '#b91c1c',
      fontFamily: '"DM Sans", ui-sans-serif, system-ui, sans-serif',
    },
  }

  if (!clientSecret) {
    return <CircularProgressContinuous />
  }

  const options = {
    clientSecret,
    appearance,
    fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400..700;1,400..700&display=swap' }],
  }

  return (
    <Elements options={options} stripe={stripePromise}>
      <CheckoutForm checkoutButtonCopy={checkoutButtonCopy} supportTrial={supportTrial} />
    </Elements>
  )
}

export default CheckoutContainer
